import { IEmailProvider, EmailData, EmailResponse } from '../types';

/**
 * Custom Backend Provider
 * Para cuando tengas tu propio servidor Express/NestJS/etc
 */
export class CustomBackendProvider implements IEmailProvider {
  private apiUrl: string;

  constructor() {
    this.apiUrl = process.env.REACT_APP_CUSTOM_API_URL || 'http://localhost:3001/api/send-email';
  }

  async sendEmail(data: EmailData): Promise<EmailResponse> {
    try {
      const response = await fetch(this.apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Añade headers de autenticación si los necesitas
          // 'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || 'Failed to send email');
      }

      return {
        success: true,
        message: result.message || 'Email sent successfully via Custom Backend',
      };
    } catch (error: any) {
      return {
        success: false,
        error: error.message || 'Failed to send email via Custom Backend',
      };
    }
  }
}
